import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { UserTheme } from "../users";
import { OmitStrict } from "../utils";

export const PortalSettingsTheme = UserTheme;

export const PortalSettingsSidebarLink = z.object({
  name: z.string(),
  url: z.string(),
  emoji: z.string(),
});
export const PortalSettingsSidebarSection = z.object({
  sectionName: z.string(),
  links: z.array(PortalSettingsSidebarLink),
});
export const PortalSettingsSidebar = z.array(PortalSettingsSidebarSection);

export const PortalSettings = z.object({
  id: z.string(),
  workspaceId: z.string(),

  enabledDesignSystemIds: z.array(z.string()),
  enabledBrandPersistentIds: z.array(z.string()),

  theme: PortalSettingsTheme.nullish(),
  sidebar: PortalSettingsSidebar.nullish(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PortalSettingsTheme = z.infer<typeof PortalSettingsTheme>;
export type PortalSettings = z.infer<typeof PortalSettings>;
export type PortalSettingsSidebarLink = z.infer<typeof PortalSettingsSidebarLink>;
export type PortalSettingsSidebarSection = z.infer<typeof PortalSettingsSidebarSection>;
export type PortalSettingsSidebar = z.infer<typeof PortalSettingsSidebar>;
export type CreatePortalSettings = DbCreateInputOmit<PortalSettings>;
export type UpdatePortalSettings = OmitStrict<DbUpdate<PortalSettings>, "workspaceId">;
